//write code for jobOrders
import {getAllJobOrders} from "./services";

// Action Types
export const GET_JOB_ORDERS_REQUEST= "GET_JOB_ORDERS_REQUEST";
export const GET_JOB_ORDERS_SUCCESS = "GET_JOB_ORDERS_SUCCESS";
export const GET_JOB_ORDERS_FAILURE = "GET_JOB_ORDERS_FAILURE";


// Action Creators

export const getJobOrderRequest = () => {
    return {
        type: GET_JOB_ORDERS_REQUEST,
    };
}

export const getJobOrdersSuccess = (jobOrders) => {
    return {
        type: GET_JOB_ORDERS_SUCCESS,
        payload: jobOrders,
    };
}

export const getJobOrdersFailure = (error) => {
    return {
        type: GET_JOB_ORDERS_FAILURE,
        payload: error,
    };
}

export const getJobOrdersAction = () => async (dispatch) => {
    try {
        dispatch(getJobOrderRequest);
        const response = await getAllJobOrders();
        dispatch(getJobOrdersSuccess(response.data));
    } catch (error) {
        console.log(error);
        dispatch(getJobOrdersFailure(error.message));
    }
}